module.exports = __webpack_public_path__ + "img/13_1803_hill.f74d1660.jpg";